export default __webpack_public_path__ + "static/media/profile-thumb.81fdb85f.png";